<template>
    <div class="footer">
        <!--    输入联想-->
        <div class="lenovo_bg">
            <div class="lenovo" v-if="robotTipsEnable && robotTips.length > 0">
                <div @click="sendRobotTips(lenovo)" v-for="lenovo in robotTips" :key="lenovo.id" v-html="lenovo.tips">
                </div>
            </div>
        </div>
        <div class="foot_input">
            <!-- <span
                v-if="userInfo.status !== 2 && userInfo.status !== 3 && initData.receiveMode !== 3 && initData.receiveMode !== 2"
                class="transform" @click="transfer">
                <span class="icon"></span>
                <span class="icon_title">{{ $t('transform') }}</span>
            </span> -->
            <!-- <span
              v-if="!voiceFlag"
              class="transform"
              @click="voiceFlag=true"
            >
              <span class="icon2"></span>
            </span>
            <span
              v-if="voiceFlag"
              class="transform"
              @click="voiceFlag=false"
            >
              <span class="icon3"></span>
            </span>
            <div
              class="input"
              v-if="voiceFlag"
            >
              <div
                class="voiceBtn"
                @touchstart.prevent="voiceBegin"
                @touchend.prevent="voiceEnd"
                @touchmove="touchmove"
              >{{btRecoding?'松开结束':'按住说话'}}</div>
              <span
                v-if="userInfo.status === 2"
                class="emoticon"
                @click="clickMenu(true,'showEmoji')"
              ></span>
            </div> -->
            <div class="input" v-if="!voiceFlag">
                <div id="input" @focus="clickMenu(false)" @blur='blurBtn' ref="input" v-on:input="listenerInput"
                    v-model="content" contenteditable :placeholder="$t('input')"></div>
                <!-- <span v-if="userInfo.status === 2" class="emoticon" @click.stop="clickMenu(true, 'showEmoji')"></span> -->
            </div>
            <span class="send_menu">
                <span :style="{ backgroundColor: initData.kitBgcolor }" v-if="showSendBtn" class="send_btn"
                    @click.vative="sendMessage()">{{ sendBtn }}</span>
                <span v-if="!showSendBtn" :class="showModal ? 'menu_btn active' : 'menu_btn'"
                    @click="clickMenu(true, 'showMenus')"></span>
            </span>

        </div>
        <!--    菜单和表情-->
        <FooterMenus @chooseEmojiFn="clickEmoji"></FooterMenus>

        <!--   分组接待-->
        <Popup style="width:100%;z-index:2" v-model="showChannelGroupFlag" position="bottom" :closeOnClickModal='false'>
            <div class="form_user" v-if="showFormChat">
                <p>{{ initData.userForm.formTitle }}</p>
                <div v-for="item in formData.formList" v-if="item.show">
                    <span class="label">
                        <span class="red" v-if="item.require">*</span>{{ item.name }}</span>
                    <el-input :maxLength="16" v-model="item.value" type="text" placholder="请输入"></el-input>
                </div>
                <Button @click="submitForm"    :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }" type="default" size="normal">{{ $t('submit') }}
                </Button>
            </div>
            <div class="groupList" v-if="!showFormChat">
                <div class="group_item" :style="{ color: initData.kitBgcolor, border: `1px solid ${initData.kitBgcolor}` }"
                    v-for="group in channelGroup" :key="group.id" @click="selectGroup(group)">{{ group.groupName }}
                </div>
            </div>
        </Popup>
        <div class="chatOut" v-if="!chatStatus">
            <!-- <span v-if="!!(initData.workorderMode*1)" @click="messageFn()">
              <a class="icon" style="width:20px;height:20px;margin-bottom: 5px">
      <svg t="1641726401273" style="width:20px;height:20px" viewBox="0 0 1250 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2158" width="16" height="16"><path d="M1193.638811 283.375538a56.839943 56.839943 0 0 1 56.839943 56.839943L1250.933474 852.599151H1250.478754v56.839943a113.679887 113.679887 0 0 1-113.679886 113.679887h-60.39244l-902.334101 0.426299V1023.118981H113.679887a113.395687 113.395687 0 0 1-113.168328-108.649552L0 113.196747A113.395687 113.395687 0 0 1 108.535872 0.511559L1137.225167 0a113.310427 113.310427 0 0 1 107.995893 81.309539 57.522023 57.522023 0 0 1-10.77117 15.858344s0 0.19894-0.198939 0.2842L672.78599 601.309761a39.78796 39.78796 0 0 1-28.419972 21.087619 56.839943 56.839943 0 0 1-61.614498-12.476368 53.770586 53.770586 0 0 1-6.792374-10.231189l-332.513668-275.673726a56.839943 56.839943 0 0 1 80.400099-80.4001l300.143321 248.987372L1046.195998 113.679887l-861.636702 0.397879c-57.863062 1.989398-68.804751 12.931087-70.794149 70.19733l0.397879 667.244096c2.841997 48.313952 15.517305 56.271544 70.16891 57.578862l-70.14049-0.454719v1.222059l1023.118981-0.45472v-0.767339l-81.281119 0.511559c79.121201-1.449419 81.167439-13.471067 81.195859-110.04213L1136.798868 340.215481a56.839943 56.839943 0 0 1 56.839943-56.839943zM148.210152 114.163026H113.679887v0.19894z m36.093364 795.020288l44.391996 0.2842c-17.336183-0.02842-31.830368-0.02842-44.363576-0.2842z" p-id="2159" fill="#dbdbdb"></path></svg>        </a>
              <a>留言</a>
              </span> -->
            <span @click="closeChat">
                <a class="icon">
                    <!-- <svg t="1641725674189" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="1880" width="64" height="64">
                        <path
                            d="M800 704v17.888h-184.128c-29.664 0-61.184 18.848-74.912 44.832L512 821.44l-28.96-54.752c-13.728-25.952-45.248-44.8-74.912-44.8H224V256h576v448z m5.312-512H218.688C186.336 192 160 219.488 160 253.248v471.392c0 33.76 26.4 61.248 58.816 61.248h189.312c5.92 0 15.712 5.728 18.368 10.752l38.048 71.968 2.912 4.544c11.168 14.528 27.392 22.848 44.544 22.848 17.152 0 33.376-8.32 44.544-22.848l40.96-76.512c2.464-4.608 11.968-10.752 18.368-10.752h189.472c32.352 0 58.656-27.488 58.656-61.248V253.248C864 219.488 837.664 192 805.312 192z"
                            p-id="1881" fill="#dbdbdb"></path>
                        <path
                            d="M336 448c-12.352 0-23.488 4.8-32 12.448A47.68 47.68 0 0 0 288 496c0 14.176 6.24 26.752 16 35.552a47.68 47.68 0 0 0 32 12.448 48 48 0 0 0 0-96M688 448a48 48 0 0 0 0 96c12.352 0 23.488-4.8 32-12.448 9.76-8.8 16-21.376 16-35.552a47.68 47.68 0 0 0-16-35.552 47.68 47.68 0 0 0-32-12.448M512 448c-12.352 0-23.488 4.8-32 12.448a47.68 47.68 0 0 0-16 35.552c0 14.176 6.24 26.752 16 35.552A47.68 47.68 0 0 0 512 544c12.352 0 23.488-4.8 32-12.448 9.76-8.8 16-21.376 16-35.552a47.68 47.68 0 0 0-16-35.552A47.68 47.68 0 0 0 512 448"
                            p-id="1882" fill="#dbdbdb"></path>
                    </svg> -->
                    <img src="../../../static/image/damo/new.png" alt="" srcset="">
                </a>
                <a style=" color: rgb(10, 164, 226);">{{ $t("reChat") }}</a>
            </span>
            <!-- <span v-if="!!(initData.evaluateMode * 1)" @click="evaluateFn()">
                <a class="icon">
                    <svg t="1641727265972" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="3920" width="64" height="64">
                        <path
                            d="M841.900615 408.186609 664.015206 408.186609c-4.087085 0-7.605212-1.823532-9.635451-4.979408-2.044566-3.188622-2.387373-6.788613-0.932232-10.313903 10.105149-19.105127 57.494459-115.41052 44.899606-217.797421-3.51915-28.749788-18.948561-67.455321-72.482825-88.576361-13.886265-5.465478-39.682791-8.026814-59.192124-8.601912-46.860261-1.38044-56.329936 7.693216-60.373019 11.568477-0.164752 0.155543-0.324388 0.316202-0.484024 0.476861C490.730581 105.371886 491.958548 127.455857 493.514997 155.415652c0.795109 14.287401 1.694595 30.466895 0.857531 48.953945-4.579295 49.570999-11.171434 76.334549-24.283056 98.636484-40.689724 69.270666-109.423155 104.141872-122.656551 105.213273l-96.509031 0L86.587054 408.219355c-11.761881 0-21.296025 9.534144-21.296025 21.296025L65.291029 844.261383c0 11.760858 9.534144 21.296025 21.296025 21.296025l164.337859 0c0.858554 0 1.700735-0.065492 2.533706-0.164752l104.601336 0c1.191128 0.969071 2.534729 2.081405 3.739161 3.082198 22.952758 19.025309 83.921341 69.563332 184.571692 69.563332l209.634508 0c53.634548 0 96.863095-29.224602 112.819508-76.270081 0.13917-0.409322 0.26606-0.823761 0.38067-1.24127 2.246157-8.247848 8.025791-25.420973 15.344476-47.162136 27.735691-82.408895 74.159-220.339314 74.159-294.15653C958.708971 446.576965 918.317029 408.186609 841.900615 408.186609zM107.883079 450.812429l121.744785 0 0 372.152928L107.883079 822.965357 107.883079 450.812429zM844.182588 799.778262c-7.649214 22.723537-13.225209 39.289841-15.882736 48.862871-10.205433 29.319769-37.183877 46.803979-72.293513 46.803979l-209.634508 0c-85.292572 0-135.816269-41.879829-157.38961-59.763129-9.691733-8.03193-15.541975-12.881378-24.845874-12.881378l-91.914386 0L272.221962 450.812429l75.364455 0c20.070104 0 51.52142-17.555841 74.262354-33.985022 24.394596-17.623379 58.936297-47.932686 84.96409-92.242867 19.039635-32.386618 25.602098-68.703755 30.019711-116.802216 0.029676-0.317225 0.051165-0.63445 0.066515-0.952698 0.975211-20.862143-0.039909-39.114856-0.855484-53.780881-0.63445-11.403724-1.402953-25.209148-0.179079-31.395034 15.941064-3.081175 61.369719-0.632403 74.387197 4.490268 27.712155 10.934027 42.701544 28.639271 45.822628 54.138014 11.341303 92.193749-35.07689 182.903703-40.407292 192.944384-0.493234 0.932232-0.74906 1.486864-0.74906 1.486864-7.703449 16.70138-6.353708 35.947723 3.624551 51.509141 9.889231 15.376199 26.888394 24.556279 45.473681 24.556279l177.88541 0c52.712549 0 74.215282 19.825534 74.215282 68.429509C916.115897 586.05053 869.322152 725.084073 844.182588 799.778262z"
                            p-id="3921" fill="#dbdbdb"></path>
                    </svg>
                </a>
                <a>{{ $t('evaluate') }}</a>
            </span> -->
        </div>
    </div>
</template>

<script>
import FooterMenus from "./footMenu";
import chatApi from "../methods";
import { Popup, Button, Toast } from "mint-ui";
import store from "../../store/index";

import bus from "@/utils/bus";
// import Recorder from "js-audio-recorder";

// const lamejs = require("lamejs");
// const recorder = new Recorder({
//   sampleBits: 16,
//   sampleRate: 48000,
//   numChannels: 1,
// });

export default {
    name: "Footer",
    data() {
        return {
            formData: {},
            sendBtn: this.$t('sendBtn'),
            showSendBtn: false, // 发送按钮
            content: "",
            enableTyping: true, // 正在输入
            showChannelGroupFlag: false, // 技能组背景
            setTimeoutId: null, //联想 和 正在输入定时器
            voiceFlag: false,
            btRecoding: false,
            blackBoxSpeak: false,
            startY: "",
            bfscrolltop: 0,
            inputinterval: "",
        };
    },
    components: {
        FooterMenus,
        Popup, Button
    },
    created() {
        // navigator.getUserMedia =
        //   navigator.getUserMedia ||
        //   navigator.webkitGetUserMedia ||
        //   navigator.mozGetUserMedia ||
        //   navigator.msGetUserMedia;

        // navigator.getUserMedia(
        //   {audio: true},
        //   function onSuccess(stream) {
        //     console.log("已点击允许,开启成功");
        //   },
        //   function onError(error) {
        //     console.log("错误：", error);
        //   }
        // );


    },
    mounted() {
        window.appSendMsg = this.appSendMsg;
        document.getElementById("input").addEventListener("paste", (event) => {
            console.log('sfsdfasdgasdgs')
            event.preventDefault();
            let text;
            let clp = (event.originalEvent || event).clipboardData;
            // 兼容针对于opera ie等浏览器
            if (clp === undefined || clp === null) {
                text = window.clipboardData.getData("text") || "";
                if (text !== "") {
                    if (window.getSelection) {
                        // 针对于ie11 10 9 safari
                        let newNode = document.createElement("span");
                        newNode.innerHTML = text;
                        window.getSelection().getRangeAt(0).insertNode(newNode);
                    } else {
                        // 兼容ie10 9 8 7 6 5
                        document.selection.createRange().pasteHTML(text);
                    }
                }
            } else {
                // 兼容chorme或hotfire
                text = clp.getData('text/plain') || "";
                if (text !== "") {
                    document.execCommand('insertText', false, text);
                }
            }
        });

    },
    computed: {
        chatStatus() {
            return this.$store.state.chatStatus;
        },
        showFormChat() {
            return this.$store.state.showFormChat;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        // 菜单 表情的背景
        showModal() {
            return this.$store.state.configH5.showModal;
        },
        // 分组接待背景
        showChannelGroup() {
            this.showChannelGroupFlag = this.$store.state.showChannelGroup;
        },
        // 技能组
        channelGroup() {
            return this.$store.state.channelGroup;
        },
        // 输入联想
        robotTipsEnable() {
            return this.$store.state.robotTipsEnable;
        },
        robotTips() {
            return this.$store.state.robotTips;
        },
        initData() {
            try {
                if (this.$store.state.initData.userForm) {
                    this.formData = JSON.parse(JSON.stringify(this.$store.state.initData.userForm));
                }
            } catch (e) {
            }
            return this.$store.state.initData;
        },
    },
    watch: {
        chatStatus() {
            return this.$store.state.chatStatus;
        },
        showFormChat() {
            return this.$store.state.showFormChat;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        showModal() {
            return this.$store.state.configH5.showModal;
        },
        showChannelGroup() {
            this.showChannelGroupFlag = this.$store.state.showChannelGroup;
        },
        channelGroup() {
            return this.$store.state.channelGroup;
        },
        showChannelGroupFlag() {
            if (!this.showChannelGroupFlag) {
                this.$store.dispatch("setShowChannelGroup", false);
            }
        },
        // 输入联想
        robotTipsEnable() {
            return this.$store.state.robotTipsEnable;
        },
        robotTips() {
            return this.$store.state.robotTips;
        },
    },
    methods: {
        evaluateFn() {
            // 没有咨询过不能评价
            if (this.$store.state.enableEvaluate) {
                chatApi.getEvaluateMsg(() => {
                    this.$store.dispatch("setConfigPc", [
                        { key: "showModal", value: true },
                        {
                            key: "evaluateModal",
                            value: true,
                        },
                    ]);
                });
            } else {
                let obj = {
                    senderType: 4, // 消息类型 1文本
                    msgContent: this.$t('chatAfterEva'),
                };
                this.$store.dispatch("setChatList", obj);
                this.$store.dispatch('setScrollBottom')
            }
        },
        messageFn() {
            this.$store.dispatch("setConfigPc", [
                { key: "showModal", value: true },
                { key: "messageModal", value: true },
            ]);
        },
        submitForm() {
            console.log(this.formData)
            for (let i = 0; i < this.formData.formList.length; i++) {
                if (this.formData.formList[i].require && this.formData.formList[i].show && !this.formData.formList[i].value) {
                    console.log(this.formData.formList[i])
                    Toast({
                        message: this.$t('pleInput') + `请填写${this.formData.formList[i].name}` + this.$t('content'),
                        duration: 3000
                    });
                    return
                }
            }
            let phoneFormat = /^1[0-9]{10}$/;
            if (this.formData.formList[1].value && !phoneFormat.test(this.formData.formList[1].value)) {
                Toast({
                    message: this.$t('rightPhone'),
                    duration: 3000
                });
                return
            }
            let formatEmail = /^[a-zA-Z0-9]+([-_\.][a-zA-Z0-9]+)*(?:@(?!-))(?:(?:[a-zA-Z0-9-]*)(?:[a-zA-Z0-9](?!-))(?:\.(?!-)))+[a-zA-Z]{2,}$/
            if (this.formData.formList[2].value && !formatEmail.test(this.formData.formList[2].value)) {
                Toast({
                    message: this.$t('rightEmail'),
                    duration: 3000
                });
                return
            }

            let data = {
                userName: this.formData.formList[0].value,
                phone: this.formData.formList[1].value,
                email: this.formData.formList[2].value,
            }
            chatApi.submitUserForm(data)
        },
        // 重新会话
        closeChat() {
            window.location.reload();
        },
        // 转人工
        transfer() {
            chatApi.chatForm();
        },
        // 显示菜单
        clickMenu(bol, type) {
            console.log('fouce')
            if (this.showModal) {
                this.$store.dispatch("setConfigH5", [
                    { key: "showModal", value: false },
                    {
                        key: "showMenus",
                        value: false,
                    },
                    { key: "showEmoji", value: false },
                ]);
            } else {
                let typeList = [
                    { key: "showModal", value: bol },
                    { key: type, value: true },
                ];
                if (type === "showEmoji") {
                    typeList.push({ key: "showMenus", value: false });
                } else {
                    typeList.push({ key: "showEmoji", value: false });
                }
                this.$store.dispatch("setConfigH5", typeList);
            }
            if (!bol) {
                this.bfscrolltop = document.body.scrollTop;

                setTimeout(() => {
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                        var ua = navigator.userAgent.toLowerCase();
                        if (ua.match(/MicroMessenger/i) == "micromessenger") {
                            // 微信
                        } else {
                            document.body.style.height = window.innerHeight + 'px';
                        }
                        this.$refs.input.scrollIntoView();
                        this.$refs.input.scrollIntoView(false);
                        this.$refs.input.scrollIntoView({ block: "end" });
                        this.$refs.input.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
                    } else {
                        this.$refs.input.scrollIntoView();
                        this.$refs.input.scrollIntoView(false);
                        this.$refs.input.scrollIntoView({ block: "end" });
                    }

                    this.$store.dispatch("setScrollBottom");
                }, 100);
            }
        },
        blurBtn() {
            setTimeout(() => {
                clearInterval(this.inputinterval);
                document.body.scrollTop = this.bfscrolltop;
                document.body.style.height = window.innerHeight + 'px';
            }, 220)
        },
        // 监听输入
        listenerInput(data) {
            this.showSendBtn = !!data.target.innerHTML;
            // 是否显示正在输入
            if (this.$refs.input.textContent.length > 0) {
                this.enableSend = true;
            }
            // 是否显示正在输入 只有客服的时候才有  是否显示机器人联想
            if (this.enableTyping || this.robotTipsEnable) {
                if (this.setTimeoutId) {
                    clearTimeout(this.setTimeoutId);
                    this.setTimeoutId = null;
                }
                this.setTimeoutId = setTimeout(() => {
                    let param = {};
                    if (this.userInfo.status === 2) {
                        // 人工的时候是 输入提示
                        param.msgContent = this.$refs.input.textContent;
                        chatApi.userTyping(param);
                    } else if (this.userInfo.status === 1 || this.userInfo.status === 0) {
                        //  机器人的时候是输入联想
                        if (this.$refs.input.textContent) {
                            param.question = this.$refs.input.textContent;
                            chatApi.robotTips(param);
                        } else {
                            // 清空联想
                            this.$store.dispatch("setRobotTips", []);
                        }
                    }
                }, 500);
            }
            this.$refs.input.scrollIntoViewIfNeeded();
        },
        sendMessage(params) {
            var obj = {};
            if (params) {
                obj = {
                    msgContent: params.msgContent,
                    senderType: 1, // 发送人 1用户，2客服，3机器人
                    date: new Date().getTime(),
                    msgTime: new Date().getTime(),
                    sysType: "", // 系统消息类型
                    msgType: 1, // 消息类型 1文本
                    status: "loading", // 消息状态 成功后隐藏否则一直loading
                    id: "message" + new Date().getTime(),
                };
            } else {
                obj = {
                    msgContent: this.$refs.input.innerHTML,
                    senderType: 1, // 发送人 1用户，2客服，3机器人
                    date: new Date().getTime(),
                    msgTime: new Date().getTime(),
                    sysType: "", // 系统消息类型
                    msgType: 1, // 消息类型 1文本
                    status: "loading", // 消息状态 成功后隐藏否则一直loading
                    id: "message" + new Date().getTime(),
                };
                if (this.$refs.input.innerText.replace(/\s+/g, "").length <= 0) return
            }

            this.$refs.input.innerHTML = "";
            this.showSendBtn = !this.showSendBtn;
            obj.msgContent = obj.msgContent
                .replace(/&amp;/g, "&")
                .replace(/&amp/g, "&")
                .replace(/&nbsp;/g, " ");
            let res = "";
            let fn = function (msg) {
                let reg =
                    /^(((https?):\/\/)(www))[a-zA-Z0-9_\-]+((\.(com|cn|org))|(:[0-9]{2,4}))?(:[0-9]{2,4})?([:\/\(\)\?\.&\-=a-zA-Z0-9;#%_]+)?$/g;
                if (msg.match(reg)) {
                    if (!msg.match(reg)) {
                        msg =
                            '<a href="http://' + msg + '" target="_blank">' + msg + "</a>";
                    } else {
                        msg = '<a href="' + msg + '" target="_blank">' + msg + "</a>";
                    }
                } else {
                    let reg1 =
                        /((https?):\/\/)[a-zA-Z0-9_\-]+((\.(com|cn|org))|(:[0-9]{2,4}))?(:[0-9]{2,4})?([:\/\(\)\?\.&\-=a-zA-Z0-9;#%_]+)?/g;
                    let arr = msg.match(reg1);
                    let ret = '';
                    if (arr && arr.length > 0) {
                        let n = arr[0];
                        //取出第一项的匹配
                        let indexNo = msg.indexOf(n);
                        //是否有 http开头
                        let isHttpNo = n.indexOf("http");
                        if (isHttpNo >= 0) {
                            ret =
                                '<a href="' +
                                n +
                                '" target="_blank">' +
                                n +
                                "</a>";
                        } else {
                            ret =
                                '<a href="http://' +
                                n +
                                '" target="_blank">' +
                                n +
                                "</a>";
                        }
                        if (indexNo === 0) {
                            msg = ret + msg.substring(n.length, msg.length);
                        } else {
                            let a = msg.substring(0, indexNo);
                            let b = a + n;
                            let c = msg.substring(b.length, msg.length);
                            msg = a + ret + c;
                        }
                    }
                }
                return msg;
            }
            res = fn(obj.msgContent);
            obj.msgContent = res;
            //更新到聊天框
            this.$store.dispatch("setChatList", obj);
            //发送消息
            chatApi.sendMessage(obj);
            this.$refs.input.focus()
        },
        clickEmoji(html) {
            this.$refs.input.innerHTML += html;
            this.showSendBtn = true;

        },
        selectGroup(group) {
            this.$store.dispatch("setShowChannelGroup", false);
            chatApi.transfer(group);
        },
        /// 发送联想
        sendRobotTips(tips) {
            console.log(tips);
            const obj = {
                docId: tips.docId,
                click: 2,
                score: tips.score,
                msgContent: tips.question,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            this.$refs.input.innerHTML = "";
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        // voiceBegin(e) {
        //   var e = e || window.event;
        //   this.btRecoding = true;
        //   this.blackBoxSpeak = true;
        //   this.startY = e.targetTouches[0].clientY;
        //   bus.$emit("closeScreen", {
        //     btRecoding: true,
        //     blackBoxSpeak: true,
        //   });
        //   // recorder.start().then(
        //   //   () => {},
        //   //   (error) => {
        //   //     console.log(error);
        //   //   }
        //   // );
        // },
        // touchmove(e) {
        //   var e = e || window.event;
        //   const endY = e.targetTouches[0].clientY;
        //   if (this.startY < endY + 10) {
        //     this.blackBoxSpeak = true;
        //     bus.$emit("closeScreen", {
        //       btRecoding: true,
        //       blackBoxSpeak: true,
        //     });
        //   } else {
        //     this.blackBoxSpeak = false;
        //     bus.$emit("closeScreen", {
        //       btRecoding: true,
        //       blackBoxSpeak: false,
        //     });
        //   }
        // },
        // voiceEnd() {
        //   // recorder.stop();
        //   this.btRecoding = false;
        //   bus.$emit("closeScreen", {
        //     btRecoding: false,
        //     blackBoxSpeak: false,
        //   });
        // },
        appSendMsg(datas) {
            console.log("appSendMsg");
            this.sendMessage({
                // msgContent:JSON.stringify(datas)  ,
                msgContent: datas,
                type: 1,
            });
        },
    },
};
</script>
<style scoped>
.form_user button {
    background: #00A1E2;
    color: #ffffff;
    font-size: 14px;
    width: 75%;
    margin-top: 15px;
}

.form_user {
    margin: 15px 20px;
}

.form_user div .label {
    display: inline-block;
    width: 60px;
    text-align: left;
    color: #747070
}

.form_user div .el-input {
    display: inline-block;
    width: 70%;
    height: 35px;
    outline: none;
    color: #565656;
    border-radius: 3px;
    padding: 3px;
}

.form_user>div {
    margin: 15px auto;
    width: 75%;
}

.form_user p {
    margin: 25px 5px 25px;
    font-size: 14px;
    color: #6f6f6f;
}

.chatOut {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background: #fdfdfd;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.chatOut span {
    padding: 4px;
    color: #848484;
    cursor: pointer;
    width: 30%;
}

.footer {
    position: relative;
    /* background: #f5f6f9; */
}

.lenovo_bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 0;
}

.lenovo {
    position: absolute;
    bottom: 3px;
    left: 6px;
    border: 1px solid #edeaea;
    padding: 4px;
    margin: 0;
    -webkit-box-shadow: 0 0 2px #dadada;
    box-shadow: 0 0 2px #fcfcfc;
    border-radius: 4px;
    background: white;
    width: 267px;
    text-align: left;
    font-size: 13px;
    line-height: 19px;
    color: #969696;
}

.lenovo>div {
    max-width: 256px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 4px;
    cursor: pointer;
    line-height: 25px;
}

div.foot_input {
    /*height: 45px;*/
    padding: 3px 10px;
    display: flex;
    border-bottom: 0.5px solid #e6e6e6;
    border-top: 0.5px solid #e6e6e6;
}

.footer>div.foot_input>span {
    display: inline-block;
    align-self: flex-end;
}

.transform {
    width: 40px;
    height: 40px;
    font-size: 0;
    margin: 2px 0;
}

.transform .icon {
    width: 25px;
    height: 19px;
    background-image: url(../../../static/image/H5_ui.png);
    background-size: 286px 74px;
    display: inline-block;
    margin: 0 auto 3px;
    background-position: -2px -31px;
}

.transform .icon_title {
    display: block;
    height: 14px;
    font-size: 10px;
    color: #999;
    overflow: hidden;
}

div.input {
    margin: 3px;
    display: inline-block;
    flex: 1;
    position: relative;
    padding: 1px 5px;
    align-self: flex-end;
    overflow: hidden;
}

div#input {
    border-radius: 3px;
    outline: none;
    max-height: 60px;
    background: #fff;
    text-align: left;
    height: 23px;
    border: none;
    line-height: 24px;
    color: #858486;
    padding: 7px;
    padding-right: 31px;
    overflow: hidden;
}

#input>div {
    line-height: 20px;
}

.emoticon {
    position: absolute;
    width: 30px;
    height: 30px;
    /*background-image: url("../../../static/image/emoticon.png");*/
    /*background-size: 100% 100%;*/
    right: 9px;
    bottom: 4px;
    background-image: url("../../../static/image/H5_ui.png");
    /*background-image: url("../../../static/image/menu.png");*/
    /*background-size: 100% 100%;*/
    background-size: 296px 79px;
    background-position: -413px 0;
}

#input:empty:before {
    content: attr(placeholder);
    color: #bbb;
}

#input:focus:before {
    content: none;
}

.send_menu {
    /*width: 30px;*/
    height: 30px;
    margin: 8px 5px;
}

.send_btn {
    display: inline-block;
    height: 31px;
    background: #00A1E2;
    color: white;
    font-size: 14px;
    line-height: 31px;
    border-radius: 26px;
    letter-spacing: 2px;
    padding: 1px 12px;
}

.send_menu.active .send_btn {
    display: inline-block;
}

.menu_btn {
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url("../../../static/image/H5_ui.png");
    /*background-image: url("../../../static/image/menu.png");*/
    /*background-size: 100% 100%;*/
    background-size: 296px 79px;
    background-position: -443px 0;
}

.menu_btn.active {
    /*background-image: url("../../../static/image/close.png");*/
    background-position: -473px 0;
}

.groupList {
    min-height: 300px;
    background: white;
}

.group_item {
    display: inline-block;
    padding: 7px 20px;
    border: 1px solid #b3e1f6;
    border-radius: 5px;
    margin: 10px;
    width: 30%;
}


.voiceBtn {
    border-radius: 3px;
    outline: none;
    max-height: 60px;
    background: #fff;
    text-align: center;
    height: 23px;
    border: none;
    line-height: 24px;
    color: #858486;
    padding: 7px;
}

.transform .icon2 {
    width: 40px;
    height: 40px;
    background-image: url(../../../static/image/voice.png);
    background-size: cover;
    display: inline-block;
}

.transform .icon3 {
    width: 40px;
    height: 40px;
    background-image: url(../../../static/image/keyboard.png);
    background-size: cover;
    display: inline-block;
}

.icon {
    display: inline-block;
    width: 30px;
    height: 30px;
}

.icon+a {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/footer.vue